import { useState } from "react";

import { SesameStreetParade } from "./SesameStreetParade";

export const SesameStreet: React.FC = () => {
  const [active, setActive] = useState(false);
  return (
    <>
      <span onClick={() => setActive(true)} className="cursor-pointer hover:text-text-secondary transition-colors">
        Sesame Street
      </span>
      {active && <SesameStreetParade onComplete={() => setActive(false)} />}
    </>
  );
};
